const CentralAfricanRepublicSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111126)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M37.568 10.4344C34.9836 5.69773 30.5396 2.12203 25.2172 0.6875L24.3477 10.4344H37.568Z"
        fill="#0052B4"
      />
      <path
        d="M2.43164 10.4344H15.652L14.7824 0.6875C9.46 2.12203 5.01609 5.69781 2.43164 10.4344Z"
        fill="#0052B4"
      />
      <path
        d="M24.3481 20V29.5652H37.5685C39.1188 26.7238 40.0003 23.4648 40.0003 20H24.3481Z"
        fill="#6DA544"
      />
      <path
        d="M15.6522 20H0C0 23.4648 0.881484 26.7238 2.4318 29.5652H15.6521V20H15.6522Z"
        fill="#6DA544"
      />
      <path
        d="M2.43164 29.5654C5.01609 34.3021 9.46 37.8778 14.7824 39.3123L15.652 30.7882L2.43164 29.5654Z"
        fill="#FFDA44"
      />
      <path
        d="M25.2172 39.3123C30.5396 37.8778 34.9836 34.3021 37.568 29.5654L24.3477 30.788L25.2172 39.3123Z"
        fill="#FFDA44"
      />
      <path d="M24.3477 30.788L37.568 29.5654H24.3477V30.788Z" fill="#FFDA44" />
      <path d="M15.652 29.5654H2.43164L15.652 30.788V29.5654Z" fill="#FFDA44" />
      <path
        d="M20.0001 0C18.1949 0 16.4463 0.240625 14.7827 0.688984V39.3111C16.4463 39.7594 18.1949 40 20.0001 40C21.8054 40 23.554 39.7594 25.2176 39.311V0.688984C23.554 0.240625 21.8054 0 20.0001 0V0Z"
        fill="#D80027"
      />
      <path
        d="M10.7578 4.34863L11.2973 6.00934H13.0437L11.631 7.03574L12.1706 8.69645L10.7578 7.67012L9.34506 8.69645L9.88482 7.03574L8.47217 6.00934H10.2183L10.7578 4.34863Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111126">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CentralAfricanRepublicSvg;
